import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {Handler} from '../../../../../../../shared/helpers/src/react/reactHelpers';
import {IconButton} from '../../../../../../../shared/ui/src/components/buttons/iconButton';
import {useUserTheme} from '../../../../../../../shared/ui/src/theme/userThemeProvider';
import {useContactsManagerContext} from '../../contactsManagerContext';
import {
  buildContactsManagerInfoBoxClickEvent,
  ContactsManagerInfoBoxActionsEnum,
} from '../../helpers/trackingHelpers';

/*
 * Props.
 */

interface InfoButtonProps {
  onToggle: Handler;
  label: ReactNode;
  isActive: boolean;
}

/*
 * Style.
 */

const StyledInfoButton = styled(IconButton)`
  margin-left: 12px;
`;

/*
 * Component.
 */

export const InfoButton: FC<InfoButtonProps> = ({label, onToggle, isActive}) => {
  const theme = useUserTheme();
  const {onTrackHandler} = useContactsManagerContext();

  const onClick = () => {
    onToggle();
    const action = isActive
      ? ContactsManagerInfoBoxActionsEnum.DISMISS
      : ContactsManagerInfoBoxActionsEnum.EXPAND;
    onTrackHandler(buildContactsManagerInfoBoxClickEvent(action));
  };

  return (
    <StyledInfoButton
      iconName="info"
      label={label}
      onClick={onClick}
      isActive={isActive}
      color={isActive ? theme.greys.shade80 : theme.greys.shade70}
      activeColor={isActive ? theme.greys.shade80 : theme.greys.shade70}
      hoverColor={theme.greys.shade80}
      hoverActiveColor={theme.greys.shade80}
      backgroundColor={isActive ? theme.greys.shade30 : undefined}
      backgroundHoverColor={isActive ? theme.greys.shade40 : theme.greys.shade30}
      isTooltipDisabled
    />
  );
};
